<template>
  <div class="view">
    <router-view />
  </div>
</template>

<script>
  import logger from '@/logger'
  import utils from '@/utils'

  export default {
    name: 'UserView',
    methods: {
      onMessage(event) {
        if (event.data.name === 'thirdPartyLogin') {
          const GOAL = this.$route.path === '/user/register' ? 'SIGNUP' : 'SIGNIN'
          if (event.data.data.success) {
            utils.reachGoal(`USER_${GOAL}_SUCCESS`)
            this.$store.dispatch('login', event.data.data.member.token)
          } else {
            utils.reachGoal(`USER_${GOAL}_FAIL`)
            logger.fail('⛔ ThirdPartyLogin failed', event.data.data.error)
          }
        }
      }
    },
    mounted() {
      window.addEventListener('message', this.onMessage)
    },
    beforeDestroy() {
      window.removeEventListener('message', this.onMessage)
    },
  }
</script>

<style scoped>
  .view { display: flex; align-items: center; justify-content: center; background: #009 url("../assets/texture.jpg"); }
  .socials { display: flex; }
  .label:hover { color: #06c!important; cursor: pointer; }
</style>
